import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export default function SavedResumeSelector({
  savedResumes,
  selectedSavedResumeId,
  onSelectSavedResume,
  loading = false,
  disabled = false,
}) {
  const hasSavedResumes = savedResumes.length > 0;

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2">Saved Resume</label>
      <Select
        value={selectedSavedResumeId || undefined}
        onValueChange={onSelectSavedResume}
        disabled={disabled || loading || !hasSavedResumes}
      >
        <SelectTrigger className="w-full" data-testid="saved-resume-select">
          <SelectValue placeholder={loading ? 'Loading saved resumes...' : 'Choose a saved resume'} />
        </SelectTrigger>
        <SelectContent>
          {savedResumes.map((savedResume) => (
            <SelectItem key={savedResume.id} value={savedResume.id}>
              {savedResume.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="mt-2 text-xs text-muted-foreground">
        {loading
          ? 'Loading your saved resumes...'
          : hasSavedResumes
            ? 'Select a saved resume to fill this field automatically.'
            : 'Uploaded resumes you save will appear here.'}
      </p>
    </div>
  );
}
